const radioSelectVariables = new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'radioSelectBg',
    {
      var: 'components.radioSelect.bg',
      cssVar: 'radio-select-bg',
      assignDefault: ['radioSelectHoverBg', 'radioSelectSelectedBg'],
    },
  ],
  [
    'radioSelectBorderRadius',
    {
      var: 'components.radioSelect.borderRadius',
      cssVar: 'radio-select-border-radius',
    },
  ],
  [
    'radioSelectBorderWidth',
    {
      var: 'components.radioSelect.borderWidth',
      cssVar: 'radio-select-border-width',
    },
  ],
  [
    'radioSelectBorderColor',
    {
      var: 'components.radioSelect.borderColor',
      cssVar: 'radio-select-border-color',
    },
  ],
  [
    'radioSelectColor',
    {
      var: 'components.radioSelect.color',
      cssVar: 'radio-select-color',
      assignDefault: ['radioSelectHoverColor', 'radioSelectSelectedColor'],
    },
  ],
  [
    'radioSelectHoverColor',
    {
      var: 'components.radioSelect.hover.initial.color',
      cssVar: 'radio-select-hover-color',
      assignDefault: [''],
    },
  ],
  [
    'radioSelectSelectedColor',
    {
      var: 'components.radioSelect.selected.color',
      cssVar: 'radio-select-selected-color',
      assignDefault: ['radioSelectSelectedHoverColor'],
    },
  ],
  [
    'radioSelectSelectedHoverColor',
    {
      var: 'components.radioSelect.hover.selected.color',
      cssVar: 'radio-select-selected-hover-color',
      assignDefault: [''],
    },
  ],
  [
    'radioSelectHoverBg',
    {
      var: 'components.radioSelect.hover.bg',
      cssVar: 'radio-select-hover-bg',
    },
  ],
  [
    'radioSelectHoverBorderColor',
    {
      var: 'components.radioSelect.hover.borderColor',
      cssVar: 'radio-select-hover-border-color',
    },
  ],
  [
    'radioSelectSelectedBg',
    {
      var: 'components.radioSelect.selected.bg',
      cssVar: 'radio-select-selected-bg',
    },
  ],
  [
    'radioSelectSelectedBorderColor',
    {
      var: 'components.radioSelect.selected.borderColor',
      cssVar: 'radio-select-selected-border-color',
    },
  ],
  [
    'radioSelectComponentsIconBg',
    {
      var: 'components.radioSelect.components.icon.bg',
      cssVar: 'radio-select-components-icon-bg',
      assignDefault: ['radioSelectComponentsIconHoverBg', 'radioSelectComponentsIconSelectedBg'],
    },
  ],
  [
    'radioSelectComponentsIconHoverBg',
    {
      var: 'components.radioSelect.components.icon.hover.bg',
      cssVar: 'radio-select-components-icon-hover-bg',
    },
  ],
  [
    'radioSelectComponentsIconSelectedBg',
    {
      var: 'components.radioSelect.components.icon.selected.bg',
      cssVar: 'radio-select-components-icon-selected-bg',
    },
  ],
  [
    'radioSelectComponentsIconColor',
    {
      var: 'components.radioSelect.components.icon.color',
      cssVar: 'radio-select-components-icon-color',
      assignDefault: ['radioSelectComponentsIconHoverColor'],
    },
  ],
  [
    'radioSelectComponentsIconSelectedColor',
    {
      var: 'components.radioSelect.components.icon.selected.color',
      cssVar: 'radio-select-components-icon-selected-color',
      assignDefault: ['radioSelectComponentsIconSelectedHoverColor'],
    },
  ],
  [
    'radioSelectComponentsIconHoverColor',
    {
      var: 'components.radioSelect.components.icon.hover.color',
      cssVar: 'radio-select-components-icon-hover-color',
    },
  ],
  [
    'radioSelectComponentsIconSelectedHoverColor',
    {
      var: 'components.radioSelect.components.icon.selected.hover.color',
      cssVar: 'radio-select-components-icon-selected-hover-color',
    },
  ],
]);

export default radioSelectVariables;
